import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';

const InvoiceDetailsModal = ({ open, onClose, invoiceData, isDark }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: isDark ? "#232334" : "#fff",
          color: isDark ? "#fff" : "#232334",
          borderRadius: 4,
        }
      }}
    >
      <DialogTitle sx={{ color: isDark ? "#f48fb1" : "#1976d2" }}>بيانات الفاتورة</DialogTitle>
      <DialogContent dividers>
        {invoiceData ? (
          <Box>
            <Typography variant="h6" sx={{ mb: 2, color: isDark ? "#f48fb1" : "#1976d2" }}>
              رقم الفاتورة: {invoiceData.id}
            </Typography>
            <Typography>التاريخ: {invoiceData.date}</Typography>
            <Typography>رقم الطلب: {invoiceData.order_id}</Typography>
            <Typography>الكاشير: {invoiceData.user?.name || "-"}</Typography>
            <Typography>العميل: {invoiceData.customer_name || invoiceData.customer?.name || "-"}</Typography>
            <Typography>الخدمة: {invoiceData.service}</Typography>
            <Typography>نسبة الخدمة: {invoiceData.service_ratio}</Typography>
            <Typography>الضريبة: {invoiceData.tax}</Typography>
            <Typography>نسبة الضريبة: {invoiceData.tax_ratio}</Typography>
            <Typography>الخصم: {invoiceData.discount}</Typography>
            <Typography>نسبة الخصم: {invoiceData.discount_ratio}</Typography>
            <Typography>الإجمالي الفرعي: {invoiceData.sub_total}</Typography>
            <Typography>الإجمالي النهائي: {invoiceData.total_amount}</Typography>
            <Typography>تاريخ الإنشاء: {invoiceData.created_at}</Typography>
            <Typography>تاريخ التحديث: {invoiceData.updated_at}</Typography>

            {/* بيانات العميل */}
            {invoiceData.customer && (
              <Box mt={2}>
                <Typography variant="subtitle1" sx={{ color: isDark ? "#f48fb1" : "#1976d2", mb: 1 }}>
                  بيانات العميل
                </Typography>
                <Typography>الاسم: {invoiceData.customer.name || "-"}</Typography>
                <Typography>الهاتف 1: {invoiceData.customer.phone1 || "-"}</Typography>
                <Typography>الهاتف 2: {invoiceData.customer.phone2 || "-"}</Typography>
                <Typography>الهاتف 3: {invoiceData.customer.phone3 || "-"}</Typography>
                <Typography>العنوان 1: {invoiceData.customer.address1 || "-"}</Typography>
                <Typography>العنوان 2: {invoiceData.customer.address2 || "-"}</Typography>
                <Typography>العنوان 3: {invoiceData.customer.address3 || "-"}</Typography>
              </Box>
            )}

            {/* بيانات الطلب المرتبط بالفاتورة */}
            {invoiceData.order && (
              <Box mt={3}>
                <Typography variant="h6" sx={{ mb: 1, color: "#43a047" }}>
                  بيانات الطلب المرتبط
                </Typography>
                <Typography>رقم الطلب: {invoiceData.order.id}</Typography>
                <Typography>نوع الطلب: {invoiceData.order.order_type}</Typography>
                <Typography>الحالة: {invoiceData.order.status}</Typography>
                <Typography>وقت الفتح: {invoiceData.order.open_time}</Typography>
                <Typography>وقت الإغلاق: {invoiceData.order.close_time || "-"}</Typography>
                <Typography>تاريخ الطلب: {invoiceData.order.date}</Typography>
                <Typography>الإجمالي: {invoiceData.order.total}</Typography>
                <Typography>الزيادة اليومية: {invoiceData.order.daily_increment}</Typography>
                <Typography>الزيادة الشهرية: {invoiceData.order.monthly_increment}</Typography>
                <Typography>الزيادة الكلية: {invoiceData.order.general_increment}</Typography>
                <Typography>تاريخ الإنشاء: {invoiceData.order.created_at}</Typography>
                <Typography>تاريخ التحديث: {invoiceData.order.updated_at}</Typography>
                {/* بيانات الطاولة */}
                {invoiceData.order.table && (
                  <Box mt={1}>
                    <Typography variant="subtitle2" sx={{ color: "#1976d2" }}>
                      بيانات الطاولة
                    </Typography>
                    <Typography>اسم الطاولة: {invoiceData.order.table.name}</Typography>
                    <Typography>QR: {invoiceData.order.table.qr_code}</Typography>
                  </Box>
                )}
                {/* عرض الأصناف */}
                {Array.isArray(invoiceData.order.items) && invoiceData.order.items.length > 0 && (
                  <Box mt={2}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                      أصناف الطلب:
                    </Typography>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>الصنف</TableCell>
                          <TableCell>الكمية</TableCell>
                          <TableCell>السعر</TableCell>
                          <TableCell>الإجمالي</TableCell>
                          <TableCell>ملاحظات</TableCell>
                          <TableCell>الحالة</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {invoiceData.order.items.map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.product?.name || "-"}</TableCell>
                            <TableCell>{item.quantity}</TableCell>
                            <TableCell>{item.price}</TableCell>
                            <TableCell>{item.total}</TableCell>
                            <TableCell>{item.note || "-"}</TableCell>
                            <TableCell>{item.status}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        ) : (
          <Typography>جاري تحميل بيانات الفاتورة...</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          إغلاق
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvoiceDetailsModal;
